import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CompanyType,
  SwitchCompanyDropdown,
} from "./Components/companyDropdown";
import { SwitchProduct } from "./Components/SwitchPlatform";
import { logoDarkImage } from "./Components/images";
import { FlyoutProfile } from "./Components/FlyoutProfile";
import FlyoutSettings from "../FlyoutSettings";
import { useGetPlatformInfo } from "../../queries/idServer";
import {
  useAuthorizationStore,
  useAuthStore,
  useCompanyStore,
  usePermissionStore,
} from "../../store";
import { queryClient } from "../../queries";
import NotificationCenter from "./Components/NotificationCenter";

export function TopBarComponent(props: any) {
  const navigate = useNavigate();
  const { accessToken } = useAuthStore();

  const { data: userPlatformData } = useGetPlatformInfo(
    accessToken || "",
    accessToken !== undefined && accessToken !== ""
  );

  const [platformData, setPlatformData] = useState<any>(null);
  const [profilePicUrl, setProfilePicUrl] = useState("");

  useEffect(() => {
    if (userPlatformData) {
      setPlatformData(userPlatformData);
      setProfilePicUrl(
        userPlatformData?.find(
          (platformData: { platform: string }) =>
            platformData.platform?.toLowerCase() === "esop"
        )?.profilePicUrl || ""
      );
    }
  }, [userPlatformData]);

  const accessiblePlatforms = Array.from(
    new Set(
      platformData
        ?.filter(
          (platform: any) =>
            platform.data.access && platform.platform !== "esop"
        )
        .map((platform: any) => platform.platform)
    )
  );

  const { clearAuthorization } = useAuthorizationStore();
  const { clearPermission } = usePermissionStore();
  const { clearCompanyData } = useCompanyStore();
  const { clear } = useAuthStore();

  const clearSessionAndRedirect = () => {
    sessionStorage.removeItem("accesstoken");
    sessionStorage.removeItem("currentUser");
    sessionStorage.removeItem("companyId");
    sessionStorage.removeItem("hissaUrl");
    queryClient.clear();
    clearAuthorization();
    clearPermission();
    clear();
    clearCompanyData();
    useCompanyStore.getState().clearCompanyData();

    window.location.href = process.env.REACT_APP_ID_SERVER_CLIENT_URL || "";
  };

  return (
    <div className="sticky top-0 right-0 left-0 z-40 bg-white shadow-box">
      <div
        className={`flex h-14 shrink-0 items-center md:gap-x-4 px-4 sm:gap-x-6 sm:px-6 lg:px-6 ${props.className}`}
      >
        <div
          onClick={() => clearSessionAndRedirect()}
          className="cursor-pointer"
        >
          {logoDarkImage ? (
            <img
              className="h-9 mx-auto w-auto"
              src={logoDarkImage}
              alt="hissa_logo"
            />
          ) : (
            <h2 className="text-4xl font-semibold text-secondary">{"hissa"}</h2>
          )}
        </div>
        <form className="relative flex flex-1" action="#" method="GET"></form>

        <SwitchCompanyDropdown />
        <div
          className="hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200"
          aria-hidden="true"
        />

        <div className="md:block">
          <FlyoutSettings />
        </div>
        <div className="md:block">
          {accessiblePlatforms.length > 0 && (
            <SwitchProduct data={platformData} />
          )}
        </div>
        <div className="md:block">
          <NotificationCenter />
        </div>
        <div className="md:block">
          <FlyoutProfile profilePicUrl={profilePicUrl} />
        </div>
      </div>
    </div>
  );
}
